import { getTelemetryHostingConfig } from '@ms/yammer-telemetry-store';

import type { YammerState } from '../../state/types';
import { getExperimentTreatment, getExperimentTreatmentIfActive } from '../experiments/selectors';

type IsEngageDomainEnabled = (state: YammerState) => boolean;
export const isEngageDomainEnabled: IsEngageDomainEnabled = (state) => {
  const isTreated = getExperimentTreatment(state, 'DomainMigration') === true;
  const hasOverride = !!getExperimentTreatmentIfActive(state, 'DomainMigration');

  return isTreated || hasOverride;
};

type ShouldUseEngageDomain = (state: YammerState) => boolean;
export const shouldUseEngageDomain: ShouldUseEngageDomain = (state) => {
  const isDevEnvironment = getTelemetryHostingConfig()?.hostingEnvironment === 'dev';
  const engageDomainEnabled = isEngageDomainEnabled(state);

  if (isDevEnvironment && !!process.env.FORCE_NEW_DOMAIN_ON_LOCALHOST) {
    return true;
  }

  if (isDevEnvironment && !!process.env.ALLOW_ENGAGE_DOMAIN) {
    return engageDomainEnabled;
  }

  return !isDevEnvironment && engageDomainEnabled;
};
